import { UserStore } from 'src/app/stores/user.store';
import { inject, Injectable } from "@angular/core";
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UserResolver implements Resolve<void> {
    readonly store = inject(UserStore);

    resolve(): Observable<void> | Promise<void> | void {
        return this.store.loadAll();
    }
}